import {
	CompletePreCheckin,
	completeStep,
	getCurrentStage,
	getSteps,
	resetStage,
	skipStep,
} from '../api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchReservationProfiles, selectSession } from './sessionSlice';

import type { RootState } from './../store';

const exampleStage = {
	stepCount: 6,
	stageAction: 'reservation/checkin/',
	stageCompletion: 1,
	reservationStageHistory: [
		{
			stageID: 1,
			isComplete: false,
			createdDate: '2023-06-22T10:14:51.983',
			updatedDate: '0001-01-01T00:00:00',
			reservationID: 1,
			stepID: 1,
			isSkipped: false,
			action: 'reservation/checkin/',
			controller: null,
			stepIcon: 'far fa-file',
			stepTitle: 'Verification',
			stepDesc: 'reserv',
			isEnabled: true,
			isMandatory: false,
		},
	],
};
const exampleStages = [
	{
		stepID: 1,
		status: 'completed',
		stepTitle: 'Verification',
		action: '/reservation/checkin/',
	},
	{
		stepID: 2,
		status: 'completed',
		stepTitle: 'Document Upload',
		action: '/scan/checkin/',
	},
	{
		stepID: 3,
		status: 'skipped',
		stepTitle: 'Upsell',
		action: '/upsell/checkin/',
	},
	{
		stepID: 4,
		status: 'skipped',
		stepTitle: 'Consent Form',
		action: '/consent/checkin/',
	},
	{
		stepID: 5,
		status: 'pending',
		stepTitle: 'Payment',
		action: '/payment/checkin/',
	},
	{
		stepID: 6,
		status: 'pending',
		stepTitle: 'Thank You',
		action: 'thankyou/checkin/',
	},
];

export const missing = [3];

/*
 * This is in relation to error value for complete and skip stage.
 * Null -> representing initial state and basically any timeslice not immediately after action
 * True -> successful execution of action
 * False -> failure case
 */

const initialState = {
	stages: null,
	stage: null,
	history: null,
	// currentProfile: null,
	error: {
		completeStage: null,
		skipStage: null,
		fetchStage: null,
		fetchStages: null,
	},
} as any;

export const completeStage = createAsyncThunk<
	object,
	{
		token: string;
		stageID: number;
		ReservationID: string;
		type: string;
		confirmationNo: string;
		stages: object[];
		propertyCode: string; //added new
		profileID?: any;
		refreshProfiles?: boolean;
	}
>('Profile/CompleteStage', async (stageParam, thunkAPI) => {
	const {
		token,
		stageID,
		ReservationID,
		type,
		confirmationNo,
		stages,
		propertyCode,
		profileID,
		refreshProfiles = false,
	} = stageParam;
	const stageList = Array.isArray(stages) ? stages : [];
	await completeStep({
		token: token,
		stageID: stageID,
		ReservationID: ReservationID,
		confirmationNo: confirmationNo,
		profileID: profileID,
	});
	if (refreshProfiles) {
		await thunkAPI
			.dispatch(fetchReservationProfiles({ token, confirmationNo }))
			.unwrap();
	}
	// await modifyReservationBooking(token);
	const response = await getCurrentStage({
		token,
		type,
		ConfirmationNo: confirmationNo,
		propertyCode,
		profileID,
	});

	// const stepID =
	// 	response?.data?.data?.reservationStageHistory[0]?.isComplete ||
	// 	response?.data?.data?.reservationStageHistory[0]?.isSkipped
	// 		? response?.data?.data?.stageCompletion + 1
	// 		: response?.data?.data?.stageCompletion;

	const completedStageIndex = stageList.findIndex((stage: any) => {
		return stage.stepID === response?.data?.data?.stageCompletion;
	});

	if (
		completedStageIndex !== -1 &&
		completedStageIndex < stageList.length - 1
	) {
		const nextStage = stageList[completedStageIndex + 1];
		console.log(nextStage);
		return nextStage;
	} else {
		const nextStage =
			stageList[completedStageIndex === -1 ? 0 : completedStageIndex] ?? null;
		return nextStage;
	}
	// const currentStage = stages.find((stage: any) => {
	// 	return stage.stepID === stepID;
	// });

	// if (currentStage !== null && currentStage !== undefined) {
	// 	return currentStage;
	// }

	// const nextStage = (
	// 	stages.find((stage: any) => (stage as any).stepID > stepID) as any
	// )?.stepID;

	// return nextStage;
});

export const skipStage = createAsyncThunk<
	object,
	{
		token: string;
		stageID: number;
		ReservationID: string;
		type: string;
		confirmationNo: string;
		stages: object[];
	}
>('Profile/SkipStage', async (stageParam, thunkAPI) => {
	const { token, stageID, ReservationID, type, confirmationNo, stages } =
		stageParam;
	const stageList = Array.isArray(stages) ? stages : [];
	await skipStep(token, stageID, ReservationID);
	const response = await getCurrentStage({
		token,
		type,
		ConfirmationNo: confirmationNo,
		propertyCode: null,
		profileID: null,
	});
	const reservationStageHistory =
		response?.data?.data?.reservationStageHistory ?? [];
	const currentHistory = reservationStageHistory[0];
	// const stepID =
	// 	response?.data?.data?.reservationStageHistory[0]?.isComplete ||
	// 	response?.data?.data?.reservationStageHistory[0]?.isSkipped
	// 		? response?.data?.data?.stageCompletion + 1
	// 		: response?.data?.data?.stageCompletion;
	// const currentStage = stages.find((stage: any) => {
	// 	return stage.stepID === stepID;
	// });
	// return currentStage;
	const completedStageIndex = stageList.findIndex((stage: any) => {
		return stage.stepID === response?.data?.data?.stageCompletion;
	});

	if (
		completedStageIndex !== -1 &&
		completedStageIndex < stageList.length - 1
	) {
		if (currentHistory?.isComplete || currentHistory?.isSkipped) {
			const nextStage = stageList[completedStageIndex + 1];
			console.log(nextStage);
			return nextStage;
		} else {
			const nextStage = stageList[completedStageIndex];
			return nextStage;
		}
	} else {
		const nextStage =
			stageList[completedStageIndex === -1 ? 0 : completedStageIndex] ?? null;
		return nextStage;
	}
});

export const fetchStage = createAsyncThunk<
	{ stage: any | undefined; history: any },
	{
		token: string;
		type: string;
		confirmationNo: string;
		stages: object[];
		profileID: any;
	}
>('Profile/FetchStage', async (stageParam, thunkAPI) => {
	const { token, type, confirmationNo, stages, profileID } = stageParam;
	const response = await getCurrentStage({
		token,
		type,
		ConfirmationNo: confirmationNo,
		profileID: profileID,
		propertyCode: null,
	});

	// const stepID =
	// 	response?.data?.data?.reservationStageHistory[0]?.isComplete ||
	// 	response?.data?.data?.reservationStageHistory[0]?.isSkipped
	// 		? response?.data?.data?.stageCompletion + 1
	// 		: response?.data?.data?.stageCompletion;
	const stageList = Array.isArray(stages) ? stages : [];
	const reservationStageHistory =
		response?.data?.data?.reservationStageHistory ?? [];
	const currentHistory = reservationStageHistory[0];
	const stepID =
		currentHistory?.isComplete || currentHistory?.isSkipped
			? response?.data?.data?.stageCompletion
			: response?.data?.data?.stageCompletion;

	const completedStageIndex = stageList.findIndex((stage: any) => {
		return stage.stepID === stepID;
	});
	let nextStage = null;
	if (
		completedStageIndex !== -1 &&
		completedStageIndex < stageList.length - 1
	) {
		if (currentHistory?.isComplete || currentHistory?.isSkipped) {
			if (completedStageIndex === 0) {
				nextStage = stageList[1];
			} else {
				nextStage = stageList[completedStageIndex + 1];
			}
		} else {
			if (completedStageIndex === 0) {
				nextStage = stageList[1];
			} else {
				nextStage = stageList[completedStageIndex];
			}
		}
	} else {
		nextStage =
			stageList[completedStageIndex === -1 ? 0 : completedStageIndex] ?? null;
	}

	console.log('nextStage----' + JSON.stringify(nextStage));

	return {
		stage: nextStage,
		history: reservationStageHistory,
	};
});

export const fetchStages = createAsyncThunk<
	object,
	{ token: string; type: string }
>('Profile/FetchStages', async (stagesParam, thunkAPI) => {
	const { token, type } = stagesParam;
	const response = await getSteps(token, type);
	return response?.data?.data;
});

export const completePreCheckin = createAsyncThunk<
	object,
	{ token: string; confirmationNo: any; profileId: any; type: string }
>('Profile/CompletePreCheckin', async (stagesParam, thunkAPI) => {
	const { token, confirmationNo, profileId, type } = stagesParam;
	const magicToken = sessionStorage.getItem('magicToken') ?? '';
	const response = await CompletePreCheckin({
		token,
		magicToken,
	});
	return response?.data?.data;
});

export const postResetStage = createAsyncThunk<
	object,
	{ token: string; profileId: any; onboardingToken: any }
>('Profile/ResetStage	', async (stagesParam, thunkAPI) => {
	const { token, profileId, onboardingToken } = stagesParam;
	const response = await resetStage({
		token,
		onboardingToken: onboardingToken ?? '',
		profileID: profileId,
	});
	return response?.data;
});

const stageSlice = createSlice({
	name: 'stage',
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(completeStage.fulfilled, (state, action) => {
			state.stage = action?.payload;
			state.error.completeStage = { status: true };
		});

		builder.addCase(completeStage.rejected, (state, action) => {
			state.error.completeStage = { status: true, result: action.error };
		});

		builder.addCase(skipStage.fulfilled, (state, action) => {
			state.stage = action?.payload;
			state.error.skipStage = { status: true };
		});

		builder.addCase(skipStage.rejected, (state, action) => {
			state.error.skipStage = { status: true, result: action.error };
		});

		builder.addCase(fetchStage.fulfilled, (state, action) => {
			state.stage = action?.payload?.stage;
			state.history = action?.payload?.history;
			// state.currentProfile = action?.payload?.currentProfile;
			state.error.fetchStage = null;
		});

		builder.addCase(fetchStage.rejected, (state, action) => {
			state.error.fetchStage = action?.error;
		});

		builder.addCase(fetchStages.fulfilled, (state, action) => {
			state.stages = action?.payload;
			state.error.fetchStages = null;
		});

		builder.addCase(fetchStages.rejected, (state, action) => {
			state.error.fetchStages = action?.error;
		});
	},
});

export const { clearError } = stageSlice.actions;
export const selectStage = (state: RootState) => state.stage;
export default stageSlice.reducer;
